import ApiConfig from "../Config";
import apiService from "../services/apiService";

// const token =
//   sessionStorage.getItem("newToken") || localStorage.getItem("newToken");
const categoryService = {
  getMainCategories: () => apiService.get(ApiConfig.getMainCat),
  fetchCategories: (mainCategoryId) =>
    apiService.get(ApiConfig.allCategory, {
      headers: {
        "main-id": mainCategoryId,
      },
    }),

  allSubcategory: (categoryId) =>
    apiService.get(ApiConfig.allSubcategory, {
      headers: {
        "category-id": categoryId,
      },
    }),

  addCategory: (categoryData) =>
    apiService.post(ApiConfig.addCategory, categoryData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  addMainCategory: (mainCategoryData) =>
    apiService.post(ApiConfig.addMainCat, mainCategoryData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  addSubCategory: (subCategoryData) =>
    apiService.post(ApiConfig.addSubCategory, subCategoryData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  editCategory: (categoryData) =>
    apiService.post(ApiConfig.editCategory, categoryData),

  editMainCategory: (mainCategoryData) =>
    apiService.post(ApiConfig.editMainCategory, mainCategoryData),

  editSubCategory: (subCategoryData) =>
    apiService.post(ApiConfig.editSubCategory, subCategoryData),
};
export default categoryService;
